import {
  PRODUCTS
} from '../../../action/types';

const {
  PRODUCT_CARTS,
  PRODUCT_INFORMATION,
  PRODUCT_ITEM
} = PRODUCTS
//initialize dashboard state-
const INIT_STATE = {
  productsCarts: [],
  productInformation: [],
  productsOrders: [],
  productItem: {
    photo: '',
    cor: 'Prota',
    pack: '7A'
  }
};
//---------------------------

/**********************
 * Auth user reducers *
 **********************/
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PRODUCT_CARTS:
      return {
        ...state,
        productsCarts: action.payload
      };
    case PRODUCT_INFORMATION:
      return {
        ...state,
        productInformation: action.payload,
        productsOrders: action.payload
      };
    case PRODUCT_ITEM:
      return {
        ...state,
        productItem: action.payload
      };

    default: return { ...state };
  }
}
